export default "__VITE_ASSET__C4AZ2GD0__"